class BrazeMessages {
    constructor(appboy) {
        this.appboy = appboy;
    }
    getMessageForSlot(targetSlotName) {
        return new Promise((resolve) => {
            const callback = (message) => {
                const { extras } = message;
                if (extras &&
                    extras.slotName &&
                    extras.slotName === targetSlotName) {
                    resolve(message);
                }
            };
            this.appboy.subscribeToInAppMessage(callback);
        });
    }
    getMessageForBanner() {
        return this.getMessageForSlot('Banner');
    }
    getMessageForEndOfArticle() {
        return this.getMessageForSlot('EndOfArticle');
    }
}
export { BrazeMessages };
